import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconEraserSimple"><Path d="M12.7319 3.5606C13.7082 2.58429 15.2912 2.58429 16.2675 3.5606L20.439 7.73218C21.4154 8.70849 21.4153 10.2914 20.439 11.2677L14.2067 17.5001L6.49958 9.79296L12.7319 3.5606Z" fill="currentColor"/><Path d="M5.79247 10.5001L3.56036 12.7322C2.58405 13.7085 2.58405 15.2914 3.56036 16.2677L7.73193 20.4393C8.70824 21.4156 10.2912 21.4156 11.2675 20.4393L13.4996 18.2072L5.79247 10.5001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraserSimple;
